<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CRow alignHorizontal="center" alignVertical="center">
        <CCol col="1">
          <CRow alignHorizontal="end">
            <div
              class="containerIconLeft"
              @click="previous"
              v-if="!mode.pretestMode && !mode.posttestMode && !mode.testmode"
            >
              <font-awesome-icon
                class="IconLeft"
                icon="chevron-left"
                size="1.5"
              ></font-awesome-icon>
            </div>
          </CRow>
        </CCol>
        <CCol col="10">
          <CRow>
            <CCol col="12">
              <CardFillText
                :question="question"
                :initialAnswer="data"
                :answer="answer"
                :correctANS="correctANS"
                :chapterName="chapterName"
                :chapterDesc="chapterDesc"
                :closePath="closePath"
                @setNext="setNext"
              />
              <CModal
                :title="ModalData.title"
                centered
                :color="ModalData.color"
                :show.sync="ShowAnswerModal"
                :closeOnBackdrop="false"
                class="CmodalShowAnswer"
              >
                <!-- <h5>{{ ModalData.data }}</h5> -->
                <template v-if="ModalData.color === 'danger'">
                  <template v-if="TrueAns.length > 1">
                    <h2>{{ ModalData.data.split("#")[0] }}</h2>
                    <h2 class="fontChinese">{{ TrueAns[0] }}</h2>
                    <h2>Or</h2>
                    <h2 class="fontChinese">{{ TrueAns[1] }}</h2>
                  </template>
                  <template v-else>
                    <h2>{{ ModalData.data.split("#")[0] }}</h2>
                    <h2 class="fontChinese">
                      {{ ModalData.data.split("#")[1] }}
                    </h2>
                  </template>
                </template>
                <template v-else
                  ><h2>{{ ModalData.data.split("#")[0] }}</h2></template
                >
                <br />
                <CRow align-vertical="end" align-horizontal="center">
                  <CButton
                    @click="ModalRoute()"
                    color="success"
                    shape="pill"
                    size="lg"
                    class="ml-2 mr-2 mt-5"
                    >Next</CButton
                  >
                </CRow>
              </CModal>
            </CCol>
          </CRow>
        </CCol>
        <CCol col="1">
          <div class="containerIconRight" @click="nextTo">
            <font-awesome-icon
              class="IconRight"
              icon="chevron-right"
              size="1.5"
            ></font-awesome-icon>
          </div>
        </CCol>
      </CRow>
    </template>
  </div>
</template>
<script>
import CardFillText from "../../components/template/Chinese1/CardFillText";
import { mapGetters } from "vuex";
import "../../assets/scss/_chineseStyle.scss";
import "../../assets/scss/_chineseModalCustom.scss";
import LoadingMDL from "../../components/loading/LoadingMDL";
import preTestTemplate from "../../assets/json/pre_test_chn.json";
import testTemplate from "../../assets/json/test_IAM08";

export default {
  components: { CardFillText, LoadingMDL },
  name: "IAM08",
  data() {
    return {
      data: [],
      pageCode: `IAM08-` + this.$route.params.id,
      answer: [],
      correctANS: "",
      next: false,
      chapterName: [],
      chapterDesc: [],
      path: "",
      closePath: "",
      previousPath: "",
      question: "",
      SetAnswer: "",
      CheckWidth: window.innerWidth.toString(),
      loaded: false,
      userTemplateData: [],
      nextPath: [],
      TrueAns: [],
      point: 0,
      correctANSLength: [],
      correctANSArray: [],
      canDoItAgain: false,
      ShowAnswerModal: false,
      ModalData: {
        title: "",
        color: "",
        data: "",
      },
      content: {},
      exceptionPath: [
        "IAM08-54",
        "IAM08-55",
        "IAM08-56",
        "IAM08-36",
        "IAM08-37",
        "IAM08-53",
        "IAM08-400",
        "IAM08-401",
        "IAM08-402",
        "IAM08-403",
        "IAM08-404",
      ],
      courseSection: "",
      startTime: "",
      answerResult: null,
      condition: {},
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      getTemplateContent: "template/getTemplateContent",
      getUserTemplate: "template/getUserTemplate",
      getCheckAnswerResult: "template/getCheckAnswerResult",
      loadingGetter: "template/loadingGetter",
    }),
  },

  watch: {
    getTemplateContent: function (val) {
      if (!val.enable) {
        alert("Access denied!");
        this.$router.push({ name: val.navigate.close.action });
      } else {
        this.data = [];
        this.content = val;
        this.nextPath = this.content.navigate.next.action;

        this.data = Array(val.content.question[0].choices.length);

        this.answer = val.content.question[0].choices;
        this.correctANS =
          val.content.question[0].choices[0].choice.choices.item.data;

        this.correctANSLength = this.correctANS.length;
        this.question = val.content.question[0].title[1].value;
        this.chapterName = val.title;
        this.chapterDesc = val.description;
        this.path = val.navigate.next.action;
        this.closePath = val.navigate.close.action;

        this.previousPath = val.navigate.previous.action;
        this.courseSection = this.$store.getters['necessary/getUserCourseSection']
        this.$store.dispatch("template/createUserTemplateData", {
          code: this.courseCode,
          template: val._id,
          section: this.courseSection,
        });
      }
    },
    getUserTemplate: function (val) {
      this.userTemplateData = val;
      this.condition =
        val.data.condition.criteriaType.length == 0
          ? []
          : {
              criteria: val.data.condition.criteriaType[0].criteria._id,
              val: val.data.condition.criteriaType[0].val,
            };
      this.loading = false;
    },
    loadingGetter: function (val) {},
    getCheckAnswerResult: function (val) {
      let all_except = ["IAM08-54", "IAM08-55"];
      let templateCode = `IAM08-` + this.$route.params.id;
      let except = all_except.filter((i) => {
        if (templateCode == i) {
          return i;
        }
      });
      if (except.length == 0) {
        if (val.userAnswer.length == 0) {
          this.ShowAnswerModal = false;
        } else {
          let isPreTest = preTestTemplate.filter((i) => {
            if (templateCode == i) {
              return i;
            }
          });
          let isTest = testTemplate.filter((i) => {
            if (templateCode == i) {
              return i;
            }
          });

          if (isPreTest.length > 0 || isTest.length >0) {
            this.ModalRoute();
          } else {
            if (val.userAnswer[0].status) {
              this.ModalData = {
                title: "Result",
                color: "success",
                data: "Correct #" + val.correctAnswer[0].correct,
              };
            } else {
              if (val.correctAnswer.length > 1) {
                this.ModalData = {
                  title: "Result",
                  color: "danger",
                  data:
                    "Incorrect. the correct answer is #" +
                    val.correctAnswer[0].correct +
                    "or" +
                    val.correctAnswer[1].correct,
                };
              } else {
                this.ModalData = {
                  title: "Result",
                  color: "danger",
                  data:
                    "Incorrect. the correct answer is #" +
                    val.correctAnswer[0].correct,
                };
              }
            }
             this.ShowAnswerModal = true;
          }
         
        }
      } else {
        let str = this.nextPath.split("-");
        this.$router.push("/" + str[0] + "/" + str[1]);
      }
    },
  },

  mounted() {
    let body = {};
    body.code = this.courseCode;
    body.templateCode = `IAM08-` + this.$route.params.id;
    this.$store.dispatch("template/fetchContent", body);
  },

  created() {
    this.courseCode = this.$store.getters["necessary/getLerningCourse"]._id;
    this.lang = this.$store.state.language.language;
    this.startTime = this.$helpers.getDateFormat();
    this.mode = this.$store.getters["necessary/getMode"];
  },

  beforeDestroy() {},
  methods: {
    checkWidth() {
      if (this.CheckWidth > 800) {
        return "container-chinese-card";
      } else if (this.CheckWidth <= 800) {
        return "container-chinese-card-mobile";
      }
      // return "container-chinese-card-mobile"
    },
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },
    setNext(status, getAnswer) {
      this.next = status;
      this.SetAnswer = "";
      for (var i = 0; i < getAnswer.length; i++) {
        if (this.SetAnswer === "") {
          this.SetAnswer = getAnswer[i];
        } else {
          this.SetAnswer = this.SetAnswer + getAnswer[i];
        }
      }
    },
    previous() {
      if (this.previousPath === "PreTest") {
        alert("You cannot exit while doing pretests.");
      } else {
        let str = this.previousPath.split("-");
        this.$router.push("/" + str[0] + "/" + str[1]);
        if (str[0] == "IAM08") {
          let body = {};
          body.code = this.courseCode;
          body.templateCode = this.previousPath;
          this.$store.dispatch("template/fetchContent", body);
        }
      }
    },
    close() {
      let str = this.closePath.split("-");
      this.$router.push("/" + str[0] + "/" + str[1]);
    },
    nextTo() {
      if (event.isTrusted && this.next) {
        let str = this.path.split("-");
        const useTime = this.$helpers.getUseTime();
        // this.userTemplateData.template = this.$helpers.setUserCriteria(
        //   this.userTemplateData.template,
        //   useTime
        // );
        let arr = [];
        arr.push(this.condition);
        this.$store.dispatch("template/saveUserTemplateData", {
          code: this.courseCode,
          template: this.content._id,
          section: this.courseSection,
          answering: [
            {
              answer: this.SetAnswer,
            },
          ],
          startTime: this.startTime,
          endTime: this.$helpers.getDateFormat(),
          condition: arr,
        });

        // IF =======================================================================
      }
    },
    ModalRoute() {
      let str = this.nextPath.split("-");
      if (str[0] == "IAM08") {
        this.$store.commit("courses/checkIsChangeComponent", true);
        this.$store.commit("template/setIsChangeTemplate");
        let body = {};
        body.code = this.courseCode;
        body.templateCode = this.path;
        this.$store.dispatch("template/fetchContent", body);
        this.loading = true;
      }
      this.$router.push("/" + str[0] + "/" + str[1]);
      this.ShowAnswerModal = false;
    },
  },
};
</script>

<style>
  
</style>
